
<!-- Wrapper Body -->
<div class="wrapper-body" >
    <div class="page-header d-flex align-items-center">
      <h3>Payments</h3>
      <a class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
    <button type="button" class="theme-button grey my-3 my-md-0" onclick="exportPaymentCSV()">Export to CSV</button>
    </div>
    <div class="content">
      <form class="custom-form d-none" [formGroup]="filterForm" id="filterShow">
        <div class="row">
          <!-- <div class="col-md-4">
            <input type="text" id="filterSearch" placeholder="Type here to search"
              onkeyup="appointmentFilterFunction()">
          </div> -->
          <div class="col-md-3">
            <input type="text" formControlName="fromDate" placeholder="From Date" min="2022-01-01" max="3000-01-01" onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
          </div>
          
          <div class="col-md-3">
            <input type="text" formControlName="toDate" placeholder="To Date" min="2022-01-01" max="3000-01-01" onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
          </div>
          <div class="col-md-2">
            <button type="button" form="intakeForm" fo class="theme-button" id="dateRangeFilter" (click)="submitFilterForm()">Search</button>
          </div>
        </div>
      </form>
      <div class="card" >
        <div class="table-responsive">
          <!-- <table class="custom-table filterTable" id="paymentTable"> -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="paymentTable" class="custom-table filterTable row-border hover">
            <thead>
              <tr class="header">
                <th>Client Name</th>
                <th>Assessment Type</th>
                <th>Location</th>
                <th>Appt. Date</th>
                <th>Diagnostician</th>
                <th>Total</th>
                <th>Total Collected</th>
                <th>Pending</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loop -->
              <tr *ngFor="let payment of paymentList, index as i ">
                <td>{{payment.clientName}} </td>
               <td class="">{{payment.assesmentType}}</td>
                <td class="">{{payment.location}}</td>
                <td class="">{{payment.appointmentDate}}</td>
                <td class="">{{payment.diagnosticianName}}</td>
                <td class="">{{payment.totalAmount}}</td>
                <td class="">{{payment.amount}}</td>
                <td class="text-danger">{{payment.remaing}}</td>
              </tr>
  
            </tbody>
          </table>
        </div>
      </div>
     
      <!-- <div *ngIf="paymentList.length<1">
         <div class="row">
          <div class="col-12">
            <div class="card py-5 px-2 text-center">
              <h4 class="text-grey">No Payments Made</h4>
              
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  

  
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>
